import img1 from '../images/partners/logo-01.png'
import img2 from '../images/partners/logo-02.png'
import img3 from '../images/partners/logo-03.png'
import img4 from '../images/partners/logo-04.png'
import img5 from '../images/partners/logo-05.png'
import img6 from '../images/partners/logo-06.png'
import img7 from '../images/partners/logo-07.png'
import img8 from '../images/partners/logo-08.png'

const dataPartners = [
    {
        img: img1,
        border: 'border-r border-b'
    },
    {
        img: img2,
        border: 'border-r border-b'
    },
    {
        img: img3,
        border: 'border-r border-b'
    },
    {
        img: img4,
        border: 'border-b'
    },
    {
        img: img5,
        border: 'border-r'
    },
    {
        img: img6,
        border: 'border-r'
    },
    {
        img: img7,
        border: 'border-r'
    },
    {
        img: img8,
        border: ''
    },
]

export default dataPartners;